import { CalendarTabs } from '../../CalendarTabs';
import { useAcademicCalendarService } from '../model';

export const AcademicCalendar = () => {
  const {
    state: { selectedTab },
    methods: { setSelectedTab },
  } = useAcademicCalendarService();
  return (
    <>
      <CalendarTabs selectedTab={selectedTab} onSelectTab={setSelectedTab} />
    </>
  );
};
